

// React imports.
import React, { Component } from "react";
import { Slider } from "@mui/material";
//app imports
import Breadcrumbs from "./Breadcrumbs";

const ChooseYears = ({ state, breadCrumbsCurrentStep }) => (

     <React.Fragment>
          <Breadcrumbs currentStep={breadCrumbsCurrentStep} />
          <fieldset>
               <legend>Choose fiscal years to report on</legend>
               <br /><br />

               <br /><br />

               {state.SelectedReport.years == 1
                    &&
                    <React.Fragment>
                         <label id="value-slider" className="font-weight-bold">
                              Selected fiscal years:&nbsp;{state.selectedYearsString}
                         </label>
                         <div style={{ "width": "90%", "margin": "auto", }}>
                              <Slider
                                   value={state.chooseYearsSelectedYearValue}
                                   onChange={state.chooseYearsHandleSliderChange}
                                   valueLabelDisplay="on"
                                   aria-labelledby="value-slider"
                                   marks={state.selectedYearsMarks}
                                   min={state.chooseYearsSliderMinYear}
                                   max={state.chooseYearsSliderMaxYear}
                              />
                         </div>
                    </React.Fragment>
               }
               {state.SelectedReport.years > 1
                    && < React.Fragment >
                         <label id="value-slider" className="font-weight-bold">
                              Selected fiscal years:&nbsp;{state.selectedYearsString}
                         </label>
                         <div style={{ "width": "90%", "margin": "auto", }}>
                              <Slider
                                   value={state.chooseYearsSelectedYearsValuesArray}
                                   onChange={state.chooseYearsHandleSliderChange}
                                   valueLabelDisplay="on"
                                   aria-labelledby="range-slider"
                                   marks={state.selectedYearsMarks}
                                   min={state.chooseYearsSliderMinYear}
                                   max={state.chooseYearsSliderMaxYear}
                              />
                         </div>
                    </React.Fragment>
               }
               <br /><br />
               <span>
                    * Data for years marked with an asterisk are preliminary pending final data validation.
               </span>
               <br /><br />
               <div style={{ "clear": "both" }}>
                    <button className="dataButton " onClick={state.chooseYearsViewReport}>View Report</button>
                    <button className="dataButton " onClick={state.chooseYearsBack}>Back one step</button>
               </div>

          </fieldset>

     </React.Fragment >

);

export default ChooseYears;
